export default {
  mon: { index: 1, name: 'Monday', key: 'mon' },
  tue: { index: 2, name: 'Tuesday', key: 'tue' },
  wed: { index: 3, name: 'Wednesday', key: 'wed' },
  thu: { index: 4, name: 'Thursday', key: 'thu' },
  fri: { index: 5, name: 'Friday', key: 'fri' },
  sat: { index: 6, name: 'Saturday', key: 'sat' },
  sun: { index: 7, name: 'Sunday', key: 'sun' },
};
